import { ChangeDetectionStrategy, Component, computed, effect } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MdsDropdownNewComponent } from '@medpacesoftwaredevelopment/designsystem';
import { StudyExpenseTrackingDataRow } from '@models/studyExpenseTrackingDataRow';
import { MdsOptionGeneric } from '@utility/utility';
import { BaseCellEditorComponent } from '../base-cell-editor/base-cell-editor.component';
@Component({
    selector: 'app-custom-cell-editor-dropdown',
    imports: [MdsDropdownNewComponent],
    standalone: true,
    templateUrl: './custom-cell-editor-dropdown.component.html',
    styleUrl: './custom-cell-editor-dropdown.component.scss',

    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomCellEditorDropdownComponent<TValue, TContext = any> extends BaseCellEditorComponent<
    StudyExpenseTrackingDataRow,
    TValue,
    TContext,
    { values: TValue[] }
> {
    options = computed(() => {
        const values = this.customParams()?.values;
        if (!values) return [];
        return values.map<MdsOptionGeneric<TValue>>((value) => ({
            value,
            viewValue: this.baseParams().formatValue(value),
        }));
    });
    formControl = new FormControl<TValue | null>(null);
    setInitialValue = effect(() => {
        const baseParams = this.baseParams();

        if (!baseParams || baseParams.value === undefined) return; // this.formControl.setValue(undefined); will cause MDS errors ;__;
        this.formControl.setValue(baseParams.value);
    });

    selectAllText = computed(() => {
        const baseParams = this.baseParams();
        if (!baseParams) return '';
        return baseParams.formatValue(this.formControl.value);
    });

    getValue(): TValue {
        return this.formControl.value;
    }
    save() {
        this.baseParams().api.stopEditing(false);
    }
}
